<template>
  <div class="content" v-if="cfg">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">{{ model.name }}</h3>
            <p class="text-sm mb-0">
              Assign members to this group
            </p>
          </template>
          <div>
            <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input v-model="searchQuery"
                            prepend-icon="fas fa-search"
                            placeholder="Search...">
                </base-input>
              </div>
            </b-col>
            <el-table :data="queriedData"
                      row-key="id"
                      header-row-class-name="thead-light"
                      @sort-change="sortChange"
                      @selection-change="selectionChange">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column min-width="120px"
                               label="Member"
                               prop="member"
                               sortable
                               align="center"
                               >
                <template v-slot="{row}">
                  <div class="d-flex">
                    <base-switch v-model="row.member" @mouseup.native="handleMemberToggle($event, row, row.member)"></base-switch>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{selectedRows.length}} rows selected
                </span>
              </p>

            </div>
            <base-pagination
              class="pagination-no-border"
              :current="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import { BasePagination } from '@/components';
import { BaseSwitch } from '@/components';
import clientPaginationMixin from './clientPaginationMixin'
import {prepareConfig} from "../../crud/config";
import crudConfig from "../../crud/crud-config";
import crudApi from "../../crud/crud-api";

export default {
  mixins: [clientPaginationMixin],
  components: {
    BaseSwitch,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  props: ['config', 'model', 'entityType', 'groupId'],
  created() {
    prepareConfig(crudConfig);
  },
  data: _ => ({
    propsToSearch: ['memberObject.name', 'memberObject.firstName', 'memberObject.lastName'],
    tableColumns: [
      {
        prop: 'memberObject.name',
        label: 'Name',
        minWidth: 160,
        sortable: true
      },
      {
        prop: 'memberObject.firstName',
        label: 'First name',
        minWidth: 160,
        sortable: true
      },
      {
        prop: 'memberObject.lastName',
        label: 'Last name',
        minWidth: 160,
        sortable: true
      },
      {
        prop: 'memberType',
        label: 'type',
        minWidth: 100
      }
    ],
    tableData: [],
    selectedRows: []
  }),
  computed: {
    cfg() {
      this.tableData = [];

      if (this.entityType === 'groups') {
        crudApi.getGroupMembers(this.model.id)
          .then(json => this.tableData = json.data ? json.data : json);
      } else if (this.entityType === 'configurationgroups') {
        crudApi.getConfigurationGroupMembers(this.model.id)
          .then(json => this.tableData = json.data ? json.data : json);
      }

      return true;
    }
  },
  methods: {
    paginationChanged(page) {
      this.pagination.currentPage = page
    },
    handleMemberToggle(event, member, value) {
      if (event.type === 'mouseup') {
        let id = member.referenceId

        if (this.entityType === 'groups') {
          if (member.memberType === 'ASSET') {
            if (value) {
              crudApi.deleteAssetFromGroup(member.groupId, id)
            } else {
              crudApi.addAssetToGroup(member.groupId, id)
            }
          } else if (member.memberType === 'DRIVER') {
            if (value) {
              crudApi.deleteDriverFromGroup(member.groupId, id)
            } else {
              crudApi.addDriverToGroup(member.groupId, id)
            }
          }
        } else if (this.entityType === 'configurationgroups') {
          if (value) {
            crudApi.deleteAssetFromConfigurationGroup(member.configurationGroupId, id)
          } else {
            crudApi.addAssetToConfigurationGroup(member.configurationGroupId, id)
          }
        }
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    dataChanged() {
      console.log("table dataChanged")
      clientPaginationMixin.data()
      clientPaginationMixin.dataChanged()
    }
  }
};
</script>
<style>
.no-border-card .card-footer{
  border-top: 0;
}
</style>
